"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
var _NotificationConfigurationFilter_1 = require("./_NotificationConfigurationFilter");
exports._LambdaFunctionConfiguration = {
    type: "structure",
    required: ["LambdaFunctionArn", "Events"],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        LambdaFunctionArn: {
            shape: {
                type: "string"
            },
            locationName: "CloudFunction"
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        Filter: {
            shape: _NotificationConfigurationFilter_1._NotificationConfigurationFilter
        }
    }
};
//# sourceMappingURL=_LambdaFunctionConfiguration.js.map